import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

// Redux store and persistence
import { store, persistor } from "./redux/store";

// Global CSS and third-party styles
import "./index.css";
import "slick-carousel/slick/slick.css";

// Main App component
import App from "./App";

// Root element
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Render the React application
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
